import { render, staticRenderFns } from "./direct-row.vue?vue&type=template&id=1dfb6a4e&"
import script from "./direct-row.vue?vue&type=script&lang=ts&"
export * from "./direct-row.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports